import { render, staticRenderFns } from "./OrderViewActionsSpecClaimed.vue?vue&type=template&id=bd26d106&"
import script from "./OrderViewActionsSpecClaimed.vue?vue&type=script&lang=js&"
export * from "./OrderViewActionsSpecClaimed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports